var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationmark = function SvgExclamationmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor",
    transform: "rotate(-90 8 8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.05 4.572q-.56 0-.812-.252A.9.9 0 0 1 7 3.676v-.28a.9.9 0 0 1 .238-.644Q7.49 2.5 8.05 2.5q.546 0 .798.252a.87.87 0 0 1 .252.644v.28a.87.87 0 0 1-.252.644q-.252.252-.798.252m-.896 1.064h1.792v7.308H7.154z"
  })));
};
export default SvgExclamationmark;